import React, { useEffect } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import {
  usePageCategoryDeleteMutation,
  usePageCategoryEditMutation,
  usePageCategoryQuery,
  usePageCategoryShowQuery,
} from "../../../graphql/pageCategory.hooks";
import { editCategorySchema } from "../validation/editCategory";
import { StyledInput } from "../../../components/inputs/styledInput";

export const EditCategory = () => {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const [editCategory, { loading: editLoading }] =
    usePageCategoryEditMutation();
  const [deleteCategory, { loading: deleteLoading }] =
    usePageCategoryDeleteMutation();
  const { data: category, loading: categoryLoading } = usePageCategoryShowQuery(
    { variables: { pageCategory: +categoryId }, fetchPolicy: "network-only" }
  );
  const { refetch: categoryRefetch } = usePageCategoryQuery();
  useEffect(() => {
    document.title = "Edit Category";
  }, []);

  const initialValues = {
    title: category?.pageCategoryShow.title || "",
  };

  const backToList = () => {
    navigate("/page/category");
  };

  const tryDeleteCategory = async () => {
    try {
      const { data } = await deleteCategory({
        variables: { pageCategory: +categoryId },
      });
      if (data.pageCategoryDelete) {
        categoryRefetch();
        backToList();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const tryCreateNewCategory = async (values: any) => {
    try {
      const { data } = await editCategory({
        variables: { pageCategory: +categoryId, title: values.title },
      });
      if (data.pageCategoryEdit.id) {
        categoryRefetch();
        backToList();
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (categoryLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Edit Page Category</h1>
        </div>
      </div>
      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <div className="d-flex flex-column flex-md-row justify-content-between col-11 col-md-8">
          <Formik
            initialValues={initialValues}
            validationSchema={editCategorySchema}
            onSubmit={tryCreateNewCategory}
            enableReinitialize
          >
            {({ handleSubmit, touched, errors }) => (
              <Form className="w-100">
                <div className="form-floating mb-3 w-100">
                  <StyledInput
                    name="title"
                    label="Title"
                    error={!!(touched.title && errors.title)}
                  />
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between col-12">
                  <button
                    onClick={backToList}
                    className="btn btn-primary text-white col-12 col-md-3 me-md-2 mb-2 mb-md-0"
                  >
                    Back To List
                  </button>
                  <button
                    type="button"
                    disabled={editLoading}
                    onClick={() => handleSubmit()}
                    className="btn btn-primary text-white col-12 col-md-3 me-md-2 mb-2 mb-md-0"
                  >
                    Update
                    {editLoading && (
                      <Spinner
                        animation="border"
                        role="status"
                        className="ms-2"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                  </button>
                  <button
                    type="button"
                    disabled={
                      deleteLoading ||
                      category.pageCategoryShow.pagePageCategories.length > 0
                    }
                    onClick={tryDeleteCategory}
                    className="btn danger-hover btn-outline-danger danger-hover text-danger col-12 col-md-3 mb-2 mb-md-0"
                  >
                    Delete
                    {deleteLoading && (
                      <Spinner
                        animation="border"
                        role="status"
                        className="ms-2"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                  </button>
                </div>
                {category.pageCategoryShow.pagePageCategories.length > 0 && (
                  <div className="text-danger text-center mt-3">
                    You cannot delete a category that contains pages.
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
